// @ts-nocheck
import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Spin,
  Form,
  Input,
  Button,
  Tooltip,
  Select,
  Divider,
  InputNumber,
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  CreateCustomer,
  Customer,
  EditCustomer,
  get,
  User,
} from '../../../../api';
import { useQuery } from '@tanstack/react-query';

type UserProps = {
  type: string;
  id?: number | null;
  add: (v: CreateCustomer) => void;
  update: (v: EditCustomer) => void;
};
const CustomerForm = (props: UserProps) => {
  const { type, id, add, update } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [sales, setSales] = useState([]);

  const { isLoading: isLoadingData, data = null } = useQuery<Customer>(
    [type],
    () => get<Customer>('/customers/' + id).then((e) => e.data)
  );
  const { isLoading: isLoadingUsers, data: usersget } = useQuery<User[]>(
    ['usuario'],
    () => get<User[]>('/users').then((e) => e.data)
  );

  useEffect(() => {
    if (usersget && Array.isArray(usersget)) {
      const filteredSales = usersget.filter(
        (user) => user.role_description === 'Sales'
      );
      setSales(filteredSales);
    }
  }, [usersget]);

  useEffect(() => {
    if (type !== 'add' && id) {
      form.setFieldsValue({
        address: data?.address,
        city: data?.city,
        country: data?.country,
        ship_to: data?.ship_to,
        credit_limit: data?.credit_limit,
        sales_user_id: data?.sales_user_id,
        company_name: data?.company_name,
        email: data?.email,
        username: data?.username,
        phone: data?.phone,
        rfc: data?.rfc,
        type: data?.type,
        state: data?.state,
        customer_type_description: data?.customer_type_description,
        zip_code: data?.zip_code,
        tax_regime: data?.tax_regime,
        suppliers: data?.supplierIds,
      });
    }
  }, [form, data, id, type]);

  const addCustomerFunction = async (values: any) => {
    setIsLoading(true);
    if (type === 'add') {
      let requestBody: CreateCustomer = {
        company_name: values.company_name,
        rfc: values.rfc || '',
        city: values.city || '',
        country: values.country || '',
        email: values.email,
        state: values.state || '',
        zip_code: values.zip_code,
        address: values.address || '',
        phone: values.phone,
        sales_user_id: values.sales_user_id,
        credit_limit: values.credit_limit,
        ship_to: values.ship_to,
      };
      add(requestBody);
    } else {
      if (id === undefined || id === null) return;
      let requestBody: EditCustomer = {
        company_name: values.company_name,
        rfc: values.rfc || '',
        city: values.city || '',
        country: values.country || '',
        email: values.email,
        state: values.state || '',
        zip_code: values.zip_code,
        address: values.address || '',
        phone: values.phone,
        sales_user_id: values.sales_user_id,
        credit_limit: values.credit_limit,
        ship_to: values.ship_to,
        id: id,
      };
      update(requestBody);
    }
    setIsLoading(false);
  };

  return (
    <Spin
      spinning={isLoading || isLoadingData || isLoadingUsers}
      tip={<p>Cargando...</p>}
    >
      <Form
        name="add-promo"
        layout="vertical"
        form={form}
        onFinish={addCustomerFunction}
      >
        <div>
          <div>
            <Divider />
            <Row gutter={16}>
              <Col xs={24} md={24}>
                <Form.Item
                  label="Empresa:"
                  name="company_name"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingrese un nombre de empresa',
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa información"
                    disabled={type === 'watch'}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={24}>
                <Form.Item
                  label="Correo electrónico:"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingrese un email',
                    },
                  ]}
                >
                  <Input
                    type={'email'}
                    placeholder="Ingresa información"
                    disabled={type !== 'add'}
                  />
                </Form.Item>
              </Col>
            </Row>
            {/* {type === 'add' && <Password type="customer" />} */}
            <Row gutter={16}>
              <Col xs={24} md={24}>
                <Form.Item
                  label="Enviar a:"
                  name="ship_to"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingrese Dirección',
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa información"
                    disabled={type === 'watch'}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  label={
                    <span>
                      Teléfono:&nbsp;
                      <Tooltip title="El número telefónico debe contener 10 dígitos">
                        <QuestionCircleOutlined />
                      </Tooltip>
                    </span>
                  }
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingresa número telefónico',
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa información"
                    disabled={type === 'watch'}
                    // maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Límite de crédito:"
                  name="credit_limit"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingresa límite de crédito',
                    },
                  ]}
                >
                  <InputNumber
                    placeholder="Ingresa información"
                    disabled={type === 'watch'}
                    style={{ width: '100%' }}
                    formatter={(value) =>
                      value
                        ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        : ''
                    }
                    parser={(value) => value?.replace(/\$\s?|,/g, '')}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Agente de ventas:"
                  name="sales_user_id"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor seleccione agente',
                    },
                  ]}
                >
                  <Select
                    disabled={type === 'watch'}
                    placeholder="Selecciona una opción"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {sales?.map((s: any) => (
                      <Select.Option key={s.id} value={s.id}>
                        {s.username}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="RFC:"
                  name="rfc"
                  rules={[
                    {
                      required: true,
                      message: 'El RFC es obligatorio',
                    },
                    {
                      pattern: /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/,
                      message: 'Ingresa un RFC válido',
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa información"
                    disabled={type === 'watch'}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <Divider>Dirección</Divider>
          <div>
            <Row gutter={16}>
              <Col xs={24} md={8}>
                <Form.Item label="Estado:" name="state">
                  <Input
                    placeholder="Ingresa información"
                    disabled={type === 'watch'}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item label="Ciudad:" name="city">
                  <Input
                    placeholder="Ingresa información"
                    disabled={type === 'watch'}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item label="País:" name="country">
                  <Input
                    placeholder="Ingresa información"
                    disabled={type === 'watch'}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={16}>
                <Form.Item label="Dirección:" name="address">
                  <Input
                    placeholder="Ingresa información"
                    disabled={type === 'watch'}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label={
                    <span>
                      CP:&nbsp;
                      <Tooltip title="El código postal debe contener 5 dígitos">
                        <QuestionCircleOutlined />
                      </Tooltip>
                    </span>
                  }
                  name="zip_code"
                >
                  <Input
                    placeholder="Ingresa información"
                    maxLength={5}
                    disabled={type === 'watch'}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <Row>
            <Col span={24}>
              <Form.Item>
                <Row justify="end">
                  <Button
                    htmlType="submit"
                    className="btn-add"
                    disabled={type === 'watch' || isLoading}
                  >
                    Guardar
                  </Button>
                </Row>
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </Spin>
  );
};

export default CustomerForm;
